// src/api/axiosConfig.js
import axios from "axios";
import { navigationService } from "../utils/navigationService";
// Create an Axios instance
const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL || "https://api.droplly.shop/v1", // Use environment variable with fallback
  headers: {
    "Content-Type": "application/json",
  },
  timeout: 6000,
  withCredentials: true,
});

// Add a request interceptor (optional: for adding tokens, etc.)
axiosInstance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("access_token"); // Example: Fetch auth token
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Add a response interceptor to handle 401 errors
axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (
      error.response &&
      error.response.status === 401 &&
      window.location.pathname !== "/login"
    ) {
      // Clear all cached data when unauthorized
      localStorage.clear();
      sessionStorage.clear();
      // Note: We can't access QueryClient here, so we'll rely on the logout utility
      // when the user manually logs out or navigates
      navigationService.redirectToLogin();
    }
    return Promise.reject(error);
  }
);

export default axiosInstance;
